if($('#are-you-crowdlending').length){
  /////////////////////
  // crowdlending-test script
  /////////////////////
  if ($("#crowdlending-test").length) {

    $('#q1a5').on('change', function () {
      if ($('#q1a5').prop('checked')) {
        $('#q1 input:not(#q1a5)').prop('checked', false);
      }
    });

    $('#q1 input:not(#q1a5)').change(function () {
      $('#q1a5').prop('checked', false);
    });

    $('#lender-result').on('click', function (e) {
      //-init
      $('.warning').removeClass('hidden').addClass('hidden')
      $('.ok').removeClass('hidden').addClass('hidden')
      $('.info').removeClass('hidden').addClass('hidden');
      var answered = true;
      var validate = true;
      //- submit
      //- check invalid fields or missing required
      $("#crowdlending-test input").each(function () {
        if ($('#' + $(this).attr('id') + ':invalid').length > 0) {
          answered = false;
        }
        if ($('div.checkbox-group.required :checkbox:checked').length < 1) {
          answered = false;
        }
      });

      //- check responses
      if (answered == true) {
        var isOk = true;

        if ($('#q1a5').prop('checked')
          || $('#q2no').prop('checked')
          || $('#q3a3').prop('checked')
          || $('#q4no').prop('checked')
          || $('#q5no').prop('checked'))
          isOk = false;

        var earnings = parseInt($('#q6a1').val());
        var percent = 1 - (parseInt($('#q7select').val()) / 100.0);
        var savings = parseInt($('#q8a1').val());
        var amountToLend = parseInt($('#q9a1').val());
        if (amountToLend > 0.1 * (earnings * percent + savings))
          isOk = false;

        if (isOk)
          $('.ok').removeClass('hidden');
        else
          $('.warning').removeClass('hidden');

      } else {
        $('.info').removeClass('hidden');
      }
    });
  }
}
